import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ServerConfigService } from './server-config.service';

@Injectable({
  providedIn: 'root',
})
export class ServerSecurityConfigService extends ServerConfigService {
  constructor() {
    super();
    this.config = {
      security: {
        host: environment.securityHost,
        port: environment.serverSecurityPort,
        basePath: environment.securityBasePath,
      },
    };
    this.setDefaultConfig('security');
  }
}
